<template>
	<div class="row">
		<div class="col-md-3 col-xs-12 form-group">
			<label>{{ _traducao('global', 'tipoUltimaIntervencao') }}:</label>
			<br />
			<p style="margin-bottom: 0px">
				{{ formulario.descricao_ultima_inspecao }}
				<small>({{ formulario.ultima_intervencao | data }})</small>
			</p>
		</div>
		<div class="col-md-3 col-xs-12 form-group">
			<label>{{ _traducao('global', 'tipoProximaIntervencao') }}:</label>
			<br />
			<p style="margin-bottom: 0px">
				{{ formulario.descricao_proxima_inspecao }}
				<small>({{ formulario.proxima_intervencao | data }})</small>
			</p>
		</div>
		<div class="col-md-3 col-xs-12 form-group">
			<label
				>{{ _traducao('global', 'horasDeCelulaParaAProxima') }} //
				{{ _traducao('global', 'disponibilidade') }}:</label
			>
			<br />
			<p v-if="formulario.horimetro_proxima == null">N/A</p>
			<p v-else>
				{{ formulario.horimetro_proxima | horimetro }} //
				{{ calculaHorimetroProximaIntervencao }}
			</p>
		</div>
		<div class="col-md-3 col-xs-12">
			<label>{{ _traducao('global', 'responsavel') }}:</label>
			<br />
			<p>
				{{
					(formulario.nome_usuario_retorno +
						' ' +
						formulario.codigo_anac_usuario_retorno)
						| na
				}}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InformacoesManutencao',

	props: {
		formulario: {
			type: Object,
			default: () => ({}),
			required: true
		}
	},

	computed: {
		calculaHorimetroProximaIntervencao() {
			let sub = Number(
				Number(this.formulario.horimetro_proxima) -
					Number(this.formulario.horimetro_final_manutencao)
			).toFixed(1)

			return sub
		}
	}
}
</script>